/**
 * 알림음 재생 함수
 */
export const playNotificationSound = () => {
  try {
    const audio = new Audio('/notification.mp3');
    audio.volume = 0.5; // 볼륨을 50%로 설정
    audio.play().catch(error => {
      console.warn('알림음 재생 실패:', error);
    });
  } catch (error) {
    console.warn('오디오 생성 실패:', error);
  }
};

/**
 * 사용자 상호작용 후 알림음 재생 (브라우저 정책 대응)
 */
export const playNotificationSoundWithUserInteraction = () => {
  // 사용자가 이미 상호작용했는지 확인
  if (document.visibilityState === 'visible') {
    playNotificationSound();
  }
}; 